module.exports = __webpack_public_path__ + "img/customer-image-vivantes.9077c06a.png";